module.exports = __webpack_public_path__ + "assets/img/icon_gold.0bbbdbc8.svg";